/* eslint-disable @next/next/no-img-element */

import { cn } from '@/lib/utils'

type SkillRibbonIconProps = {
  src: string
  size: number
  className?: string
}

export function SkillRibbonIcon({ src, size, className }: SkillRibbonIconProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('relative shrink-0 overflow-hidden', className)}
      style={{ width: size, height: size }}
    >
      <img alt="" src={src} className="absolute inset-0 h-full w-full max-w-none object-contain" />
    </div>
  )
}
